import { Stack,Text } from '@ekhodealer/ekho-common/rev';

import type { DiscountHeader } from '@ekhodealer/ekho-common';

export interface NameCellProps {
	name: DiscountHeader;
}

export const NameCell = ({ name }: NameCellProps) => {
	const secondaryInfo = [name.amountOff, name.minimum, name.use].filter(Boolean).join(' • ');

	return (
		<Stack itemsSpacing='4'>
			<Text size='bodySmall' weight='semibold'>
				{name.name}
			</Text>
			{secondaryInfo && (
				<Text size='bodySmall' color='secondary'>
					{secondaryInfo}
				</Text>
			)}
		</Stack>
	);
};
